import styled from '@emotion/styled'
import { FadeInNoDelayAnimation, FlexCenter } from '@oneToOne/shared/styles'

import { AgoraTrackPlayer } from '@core/agoraRTC'

export const TripleDotLoaderWrapper = styled.div`
  ${FlexCenter}
  position: relative;
  height: 100%;
  width: 100%;
`
export const AgentAgoraTrackPlayer = styled(AgoraTrackPlayer)`
  ${FadeInNoDelayAnimation}
  position: relative;
  height: 100%;
  width: 100%;
`
